import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import TranscriptReviewLandingPage from '../../../transcriptReview/TranscriptReviewLandingPage';

export default function TranscriptReviewRoutes() {
    return (
        <>
            <Route
                path='/transcriptreview'
                element={
                    <RequireAdmin>
                        <TranscriptReviewLandingPage />
                    </RequireAdmin>
                }
            />
        </>
    );
}
